module.exports = __webpack_public_path__ + "static/whittlesey_church_story-890cfd1c6b61ea5912d66ec0946bcadb.png";